import { DASHBOARD_BOARD_ENABLED } from '../../lib/layout-shell';
import { DashboardPage as LegacyDashboardPage } from './DashboardPage';
import { DashboardBoard } from './board/DashboardBoard';

/**
 * `/dashboard` 진입점 — 플래그로 신·구 대시보드를 가른다.
 *
 * 기존 `DashboardPage.tsx` 는 **한 줄도 손대지 않았다**. 여기서 갈라 끼우기만 하므로
 * `VITE_DASHBOARD_BOARD='0'` 면 종전 화면이 그대로 복원된다(롤백 = 환경변수 1개).
 */
export function DashboardPage() {
  return DASHBOARD_BOARD_ENABLED ? <DashboardBoard /> : <LegacyDashboardPage />;
}
